import React, {Component} from 'react';
import ReactDOM from 'react-dom'
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import Footer from "../../components/footer/component";
import HeaderHomeTwo from "../../components/header-home-two/component";
import countryCodes from "country-telephone-data";
import scrollToComponent from 'react-scroll-to-component';
import {marketRegister} from "../../services/marketRegister";
import ModalVideo from "../../components/modal-video/component";
import ModalLang from "../../components/modal-lang/component";
import {dataRegister} from "../../services/dataRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import ModalVip from "../../components/modal-vip/component";

class Vip extends Component {

    constructor(props) {
        super(props);
        this.state = {
            terms: false,
            isLoadingButton: false,
            countries: [],
            country: null,
            video: false,
            vip: false,
            form_validation: {},
            first_name: "",
            last_name: "",
            search: ""
        };
        this.signupRef = React.createRef();

        //GOOGLE ANALYTICS
        if(this.platformLive()){
            ReactGA.pageview('/vip');
            ReactGA4.send({ hitType: "pageview", page: "/vip" });
        }

        //FACEBOOK PIXEL
        if(this.platformLive()){
            ReactPixel.pageView();
        }
    };

    componentDidMount() {
        this._updateCountries();
        if(this.props.location.search === "?scrolldown=signup"){
            scrollToComponent(this.signupRef.current, { offset: 500, duration: 500});
        }else{
            window.scrollTo(0, 0);
        }
        this._setVideo = this._setVideo.bind(this);
        this._setVip = this._setVip.bind(this);
    }

    _updateCountries() {
        let countries = JSON.parse(JSON.stringify(countryCodes.allCountries));
        for (let i = 0; i < countries.length; i++) {
            countries[i].dialCode = "+" + countries[i].dialCode;
            if (countries[i].iso2 ===  marketRegister.code()) {
                this._selectCountry(countries[i]);
            }
        }
        this.setState({countries: countries});
    }

    _apply(){

        for (let key in this.state.form_validation) {
            this.state.form_validation[key] = false;
        }

        //CHECK VALUES
        this.state.form_validation.first_name = this.state.first_name === "" || !this.state.first_name;
        this.state.form_validation.last_name = this.state.last_name === "" || !this.state.last_name;
        this.state.form_validation.company = this.state.company === "" || !this.state.company;
        this.state.form_validation.address = this.state.address === "" || !this.state.address;
        this.state.form_validation.zip = this.state.zip === "" || !this.state.zip;
        this.state.form_validation.city = this.state.city === "" || !this.state.city;
        this.state.form_validation.country_name = this.state.country_name === "" || !this.state.country_name;
        this.state.form_validation.website = this.state.website === "" || !this.state.website;
        this.state.form_validation.email = !this._emailValidation(this.state.email);
        this.state.form_validation.phone = !this._phoneValidation(this.state.phone);

        try{
            this.state.form_validation.dialcode = !this.state.country.dialCode;
        }catch (e) {
            this.state.form_validation.dialcode = true;
        }

        this.setState({form_validation: this.state.form_validation});

        //CHECK IF TERMS IS SET
        if(!this.state.terms){return}

        let result = false;
        for (let key in this.state.form_validation) {
            if (this.state.form_validation[key]) {
                result = true;
                break;
            }
        }
        if(!result){
            this.setState({isLoadingButton: true});
            let information = {
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                company: this.state.company,
                address: this.state.address,
                zip: this.state.zip,
                city: this.state.city,
                country_name: this.state.country_name,
                website: this.state.website,
                email: this.state.email,
                phone: (this.state.country.dialCode&&this.state.phone!=="")?(this.state.country.dialCode + this.state.phone):this.state.phone,
            };
            let data = {email: this.state.email, name: JSON.stringify(information), subject: "vip user request", message: marketRegister.code()};
            dataRegister.industryRequest(marketRegister.code(), data).then((response) => {
                this.setState({
                    isLoadingButton: false,
                    vip: true,
                    first_name: "",
                    last_name: "",
                    company: "",
                    address: "",
                    zip: "",
                    city: "",
                    country_name: "",
                    website: "",
                    email: "",
                    phone: "",
                    terms: false
                });

                //GOOGLE EVENT
                if(this.platformLive()){
                    ReactGA.event({category: 'User', action: 'Applied VIP', label: 'Become a VIP'});
                    ReactGA4.event({category: 'User', action: 'Applied VIP', label: 'Become a VIP'});
                    //console.log("Fire event VIP");
                }

                //FACEBOOK EVENT
                if(this.platformLive()){
                    ReactPixel.trackCustom('ApplyVIP');
                }

            }, (error) => {
                this.setState({isLoadingButton: false});
            });
        }

    }

    _scrollTo(){
        scrollToComponent(this.signupRef.current, { offset: -150, duration: 500});
    }

    _selectCountry(option) {
        this.setState({country: option, search: option.dialCode});
    }

    _terms(link){
        window.open('https://legal.'+dataRegister.domain+"/"+marketRegister.code() + "/" + langRegister.lang() +"/terms/adbop", '_blank');
    }

    _setVideo(value){
        this.setState({video: value});
    }

    _setVip(value){
        this.setState({vip: value});
    }

    _login(){
        if(dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1){
            window.open("https://app.devadbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/login", '_blank');
        }else{
            window.open("https://app.adbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/login", '_blank');
        }
    }

    _emailValidation(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    _urlValidation(url) {
        var re = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/;
        return re.test(String(url).toLowerCase());
    }

    _phoneValidation(number) {
        var re = /^[0-9 +]+$/;
        if (re.test(String(number).toLowerCase()) && number.length > 5) {
            return true
        } else {
            false
        }
    }

    _renderText(item) {
        return langRegister.get("vip", item);
    }

    platformLive() {
        try {
            return window.location.hostname.indexOf('dev') === -1;
        } catch (e) {
            return false
        }
    }

    render() {
        return (
              <div className={Styles.view}>
                  {
                      this.state.video &&
                      <ModalVideo setVideo={this._setVideo} props={this.props}/>
                  }
                  {
                      this.state.vip &&
                      <ModalVip setVip={this._setVip} props={this.props}/>
                  }
                  <HeaderHomeTwo view={"about"} props={this.props}/>
                  <div className={Styles.sectionOne}>
                      <img onClick={() => this._setVideo(true)} className={Styles.sectionOneImageMobile} src={require("../../assets/images/AB_figures_mobile_reseller.png")}/>
                      <div className={Styles.sectionOneInner}>
                          <div onClick={() => this._setVideo(true)}  style={{position: "absolute", top: 0, bottom: 0, left: 0, right: 0}}/>
                          <div className={Styles.sectionOneText}>
                              {this._renderText("item_1")}
                              <div className={Styles.sectionOneTextGreen}>{this._renderText("item_2")}</div>
                              <div className={Styles.sectionOneTextGreenSmall}>
                                  {this._renderText("item_3")}
                              </div>
                              <div onClick={() => this._scrollTo()} className={Styles.sectionOneButton}>
                                  {this._renderText("item_4")}
                              </div>
                          </div>
                          <div className={Styles.sectionOneFiller}/>
                      </div>
                      <div className={Styles.sectionOneImage}>
                          <img className={Styles.sectionOneImageItem} src={require("../../assets/images/AB_figures_desktop_reseller.png")}/>
                      </div>
                      <img className={Styles.sectionOneShadow}
                           src={require("../../assets/images/AB_shadow_horisontal2_desktop_reseller.png")}/>
                      <img className={Styles.sectionOneShadowMobile}
                           src={require("../../assets/images/AB_shadow_horisontal2_mobile_reseller.png")}/>
                  </div>
                  <div className={Styles.sectionTwo}>
                      <div className={Styles.sectionTwoInner}>
                          <div className={Styles.sectionTwoText}>
                              {this._renderText("item_5")}
                              <div className={Styles.sectionTwoTextSubtitle}>
                                  {this._renderText("item_6")}
                              </div>
                              <div className={Styles.sectionTwoTextSmall}>
                                  {this._renderText("item_7")}
                              </div>
                              <div className={Styles.sectionTwoTextBullets}>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                    <div className={Styles.sectionTwoTextBulletsItemText}>
                                        {this._renderText("item_8")}
                                    </div>
                                  </div>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      <div className={Styles.sectionTwoTextBulletsItemText}>
                                          {this._renderText("item_9")}
                                      </div>
                                  </div>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      <div className={Styles.sectionTwoTextBulletsItemText}>
                                          {this._renderText("item_10")}
                                      </div>
                                  </div>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      <div className={Styles.sectionTwoTextBulletsItemText}>
                                          {this._renderText("item_11")}
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className={Styles.sectionTwoImage}>
                              {
                                  marketRegister.code() === "ae" &&
                                  <img className={Styles.sectionTwoImageItem}
                                       src={require("../../assets/images/AB_iPad_AE_EN.png")}/>
                              }
                              {
                                  marketRegister.code() === "se" && langRegister.lang() === "sv" &&
                                  <img className={Styles.sectionTwoImageItem}
                                       src={require("../../assets/images/AB_iPad_SE_SV.png")}/>
                              }
                              {
                                  marketRegister.code() === "se" && langRegister.lang() === "en" &&
                                  <img className={Styles.sectionTwoImageItem}
                                       src={require("../../assets/images/AB_iPad_SE_EN.png")}/>
                              }
                          </div>
                      </div>
                      <img className={Styles.sectionTwoShadowMobile}
                           src={require("../../assets/images/AB_shadow_horisontal2_mobile_reseller.png")}/>
                      <img className={Styles.sectionTwoShadowBottom}
                           src={require("../../assets/images/AB_shadow_horisontal2_desktop_reseller.png")}/>
                  </div>
                  <div ref={this.signupRef} className={Styles.sectionThree}>
                      <div className={Styles.sectionThreeInnerTop}>
                          <div className={Styles.sectionThreeText}>
                              {this._renderText("item_12")}&nbsp;<span className={Styles.sectionThreeTextGreen}>{this._renderText("item_13")}</span>
                          </div>
                      </div>
                      <div className={Styles.sectionThreeInnerBottom}>
                          <div className={Styles.sectionThreeSubtitle}>
                              {this._renderText("item_14")}
                          </div>
                          <div className={Styles.sectionThreeDivider}>
                              <div className={Styles.sectionThreeDividerTitle}>
                                  {this._renderText("item_15")}
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({first_name: event.target.value})} className={cx(Styles.input)} value={this.state.first_name} placeholder={this._renderText("item_16")}/>
                                  {
                                      this.state.form_validation.first_name &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({last_name: event.target.value})} className={cx(Styles.input)} value={this.state.last_name} placeholder={this._renderText("item_17")}/>
                                  {
                                      this.state.form_validation.last_name &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({company: event.target.value})} className={cx(Styles.input)} value={this.state.company} placeholder={this._renderText("item_18")}/>
                                  {
                                      this.state.form_validation.company &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({address: event.target.value})} className={cx(Styles.input)} value={this.state.address} placeholder={this._renderText("item_19")}/>
                                  {
                                      this.state.form_validation.address &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({zip: event.target.value})} className={cx(Styles.input)} value={this.state.zip} placeholder={this._renderText("item_20")}/>
                                  {
                                      this.state.form_validation.zip &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({city: event.target.value})} className={cx(Styles.input)} value={this.state.city} placeholder={this._renderText("item_21")}/>
                                  {
                                      this.state.form_validation.city &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({country_name: event.target.value})} className={cx(Styles.input)} value={this.state.country_name} placeholder={this._renderText("item_22")}/>
                                  {
                                      this.state.form_validation.country_name &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({website: event.target.value.toLowerCase()})} className={cx(Styles.input)} value={this.state.website} placeholder={this._renderText("item_23")}/>
                                  {
                                      this.state.form_validation.website &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({email: event.target.value.toLowerCase()})} className={cx(Styles.input)} value={this.state.email} placeholder={this._renderText("item_24")}/>
                                  {
                                      this.state.form_validation.email &&
                                      <div className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <div className={Styles.inputDividerItemInner}>
                                      <div className={Styles.inputDividerItemInnerDropdown}>
                                          <input
                                                placeholder={this._renderText("item_31")}
                                                type="tel"
                                                onFocus={() => this.setState({dropdown: true})}
                                                onBlur={() => this.setState({dropdown: false})}
                                                value={this.state.search}
                                                onChange={(event) => this.setState({search: event.target.value}, () => {
                                                    if(this.state.search !== this.state.country.dialCode){
                                                        console.log(this.state.country.dialCode);
                                                        this.setState({country: {}});
                                                    }
                                                })}
                                                className={Styles.inputDividerItemInnerDropdownInput}
                                          />
                                          {
                                              this.state.dropdown && this.state.countries.filter((item) => {
                                                  return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                              }).length > 0 &&
                                              <div className={Styles.dropdownList}>
                                                  {
                                                      this.state.countries.filter((item) => {
                                                          return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                      }).map((prop, key) => {
                                                          return (
                                                                <div key={key}
                                                                     onMouseDown={() => this._selectCountry(prop)}
                                                                     className={Styles.dropdownListItem}>
                                                                    {prop.dialCode}
                                                                </div>
                                                          )
                                                      })
                                                  }
                                              </div>
                                          }
                                          {
                                              this.state.form_validation.dialcode &&
                                              <div className={Styles.inputError}/>
                                          }
                                      </div>
                                      <div className={Styles.inputDividerItemInnerInput}>
                                          <input
                                                type="tel"
                                                value={this.state.phone}
                                                onChange={(event) => this.setState({phone: event.target.value.trim()})}
                                                className={Styles.input}
                                                placeholder={this._renderText("item_25")}
                                          />
                                          {
                                              this.state.form_validation.phone &&
                                              <div className={Styles.inputError}/>
                                          }
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className={Styles.inputDividerItem}>
                              <div className={Styles.checkMarksContainerItem}>
                                  {
                                      !this.state.terms &&
                                      <img onClick={() => this.setState({terms: true})}
                                           src={require("../../assets/images/square_checkmark_two.svg")}
                                           className={Styles.checkMarksContainerItemIcon}/>
                                  }
                                  {
                                      this.state.terms &&
                                      <img onClick={() => this.setState({terms: false})}
                                           src={require("../../assets/images/square_checkmark_active.svg")}
                                           className={Styles.checkMarksContainerItemIcon}/>
                                  }
                                  <div className={Styles.checkMarksContainerItemText}>
                                      {this._renderText("item_29")} <span onClick={() => this._terms()} className={Styles.checkMarksContainerItemTextBold}>{this._renderText("item_30")}</span>
                                  </div>
                              </div>
                          </div>
                          <div onClick={() => this._apply()} className={Styles.sectionThreeButton}>
                              {
                                  this.state.isLoadingButton &&
                                  <BeatLoader size={9} color={'#ffffff'} loading={true}/>
                                  ||
                                  <span>{this._renderText("item_26")}</span>
                              }
                          </div>
                          <div className={Styles.sectionThreeButtonText}>
                              {this._renderText("item_27")} <span onClick={() => this._login()} className={Styles.sectionThreeButtonTextBold}>{this._renderText("item_28")}</span>
                          </div>
                      </div>
                  </div>
                  <Footer props={this.props}/>
              </div>
        );
    }

    /*
     <div className={Styles.sectionThree}>
                      <div className={Styles.sectionThreeText}>
                          {this._renderText("item_7")}
                          <span className={Styles.sectionThreeTextGreen}>{this._renderText("item_8")}</span>
                          {this._renderText("item_9")}
                          <br className={Styles.sectionThreeTextBreak}/>
                          <span className={Styles.sectionThreeTextGreen}>{this._renderText("item_10")}</span>
                          <br className={Styles.sectionThreeTextBreak}/>
                          {this._renderText("item_11")}
                          <div className={Styles.sectionThreeTextSmall}>
                              {this._renderText("item_12")}
                          </div>
                          <div className={Styles.sectionThreeButton}>
                              {this._renderText("item_13")}
                          </div>
                      </div>
                      <div className={Styles.sectionThreeFiller}/>
                      <div className={Styles.sectionThreeImage}>
                          <img className={Styles.sectionThreeImageItem}
                               src={require("../../assets/images/AB_illustration_cards.png")}/>
                      </div>
                  </div>
     */
}

export default Vip;


// WEBPACK FOOTER //
// ./src/pages/vip/component.js